import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import { atualizarMenuPrincipalAction, limparMenuPrincipalAction } from "app/redux/menuPrincipalSlice"
import { WindowMU } from "app/types/WindowMU"
import { tratamentoErroPadrao } from "app/use-cases"
import { obterDadosLicenciamento } from "app/use-cases/obterDadosLicenciamento"
import { obterPermissao } from "app/use-cases/obterPermissao"
import globalMU from "globalMU"
import React, { useEffect, useState } from "react"
import { Login } from "./Login"
import { resetAll } from "app/redux/actions/resetAll"

declare var window: WindowMU

export const LoginContainer = () => {

    const [dadosLicenciamento, setDadosLicenciamento] = useState("")
    const [executandoLogin, setExecutandoLogin] = useState(false)

    useEffect(() => {
        atualizarDadosLicenciamento()
        store.dispatch(limparMenuPrincipalAction())
        sessionStorage.removeItem('orcamentoWebAberto') //445948
        // 491123 — permite que a checagem de orçamento em andamento (_Menu.cshtml) rode de novo a
        // cada login: sem isso, um segundo login na mesma aba (sem fechar o navegador) nunca mais
        // perguntaria, já que sessionStorage sobrevive a navegações dentro da mesma aba.
        sessionStorage.removeItem('jaVerificouOrcamentoEmAndamentoPosLogin')
    }, [])

    const atualizarDadosLicenciamento = async () => {
        if (navigator.userAgent.indexOf('Win') === -1) // 437238 - so tem licencimaneto no windows, tablet /linux nao tem licenciamento
        {
            setDadosLicenciamento("")
        }
        else {
            const dadosLicenciamento_ = await obterDadosLicenciamento()

            if (dadosLicenciamento_ == null) {
                $("#modalLicenciamento").modal();
                setDadosLicenciamento("")
            } else {
                setDadosLicenciamento(dadosLicenciamento_)
            }
        }
    }

    const obterPermissaoUsuario = async (usuario: string) => {
        store.dispatch(atualizarMenuPrincipalAction({
            nomeUsuarioLogado: usuario,
            permitirVisualizarVendas: await obterPermissao({ funcionalidade: "ORCAMENTO_VENDAS", acao: "INCLUIR" }),
            permitirVisualizarOutrasSaidas: await obterPermissao({ funcionalidade: "ORCAMENTO_OUTRAS_SAIDAS", acao: "INCLUIR" }),
            permitirVisualizarTransferencias: await obterPermissao({ funcionalidade: "ORCAMENTO_TRANSFERENCIA", acao: "INCLUIR" }),
            permitirVisualizarPesquisarOrcamento: await obterPermissao({ funcionalidade: "PESQUISAR_ORCAMENTO", acao: "CONSULTAR" }),
            permitirVisualizarCotacoesPerdidas: await obterPermissao({ funcionalidade: "ORCAMENTO_PERDA_DE_COTACAO", acao: "CONSULTAR" }),
            permitirVisualizarPesquisarProduto: await obterPermissao({ funcionalidade: "ORCAMENTO_PESQUISAR_PRODUTO", acao: "CONSULTAR" }),
            permitirVisualizarPesquisarCliente: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "CONSULTAR" }),
            permitirVisualizarPesquisarMetasBonus: await obterPermissao({ funcionalidade: "ORCAMENTO_META_BONUS", acao: "CONSULTAR" }), // PA 474948
            permitirVisualizarAtendimentoCliente: await obterPermissao({ funcionalidade: "ORCAMENTO_ATENDIMENTO_CLIENTES" }),
            permitirVisualizarUnificacaoDeOrcamentos: await obterPermissao({ funcionalidade: "ORCAMENTO_UNIFICACAO_DE_ORCAMENTOS" }), // 427169
            permitirVisualizarComissaoPorClassificacao: await obterPermissao({ funcionalidade: "ORCAMENTO_COMISSAO_POR_CLASSIFICACAO" }), // 482087
            permitirVisualizarDesdobramento: await obterPermissao({ funcionalidade: "ORCAMENTO_DESDOBRAMENTO", acao: "CONSULTAR" })
        }))
    }


    const onLogin = async (usuario: string, senha: string) => {
        let sucesso = false
        try {
            globalMU.blockScreen()
            globalMU.blockUI({ tryPassiveLoading: false })
            if (sessionStorage.getItem('aba_id') == null) {
                var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16 | 0;
                    return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
                });
                sessionStorage.setItem("aba_id", uuid);
            } 
            setExecutandoLogin(true)

            const resposta = await microuniversoApi.Login.realizarLogin({
                Usuario: usuario,
                Senha: senha,
                DadosLicenciamentoCodificados: globalMU.isNullOrEmpty(dadosLicenciamento) ? null : dadosLicenciamento
            })
            // 493081 — resposta vem null quando o servidor lanca uma excecao que NAO e
            // DomainLayerException (ex: erro de banco/mapeamento): globalMU.tratarRetorno ja
            // mostrou a mensagem generica de erro nesse caso, entao so resta nao seguir com o
            // login (sem tentar ler resposta.Status, que estouraria TypeError).
            if (resposta != null && resposta.Status == "SUCESSO") {
                store.dispatch(resetAll())
                await obterPermissaoUsuario(usuario)                   
                window.location.href = "/?XAbaId=" + sessionStorage.getItem('aba_id')
                sucesso = true
            }

        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
            globalMU.unblockScreen()
            if (!sucesso) {
                setExecutandoLogin(false)
                sessionStorage.removeItem('orcamentoWebAberto');
            }
        }

    }

    return <>
        <Login
            executandoLogin={executandoLogin}
            onLogin={onLogin} />
    </>
}

window.LoginContainer = LoginContainer